jQuery(function ($) {
    $(window).one('scroll', function trackScrollEvent() {
        if (window.trackCTA) trackCTA('scroll_start');
    });

    $('.side-nav-activator.left').sideNav({
        menuWidth: 250,
        edge: 'left',
        closeOnClick: true
    });

    $('.side-nav-activator.right').sideNav({
        menuWidth: 250,
        edge: 'right',
        closeOnClick: true
    });
});

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;

        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
}

jQuery(document).ajaxComplete(debounce(function () {
    if (window.dataLayer) {
        dataLayer.push({
            event: "refreshLinkClickTracking"
        });
    }
}, 750));